import appMode from 'helpers/getAppMode'
import NotificationToast from '_base/Notification'

export function exportSaga({ params, type = 'csv', request, requestShared, failureAction }) {
  const { domainId, reportId, dateFrom, dateTo } = params
  try {
    const req = appMode.share ? requestShared : request
    if (type === 'report') {
      req(domainId, reportId, dateFrom, dateTo)
    } else if (domainId) {
      req(domainId)
    } else {
      req()
    }
    let message =
      'Export task started. Requested file will be available in Notifications panel soon.'
    if (type === 'xls') {
      message =
        'Excel export task started. Requested file will be available in Notifications panel soon.'
    } else if (type === 'csv') {
      message =
        'CSV export task started. Requested file will be available in Notifications panel soon.'
    } else if (type === 'report') {
      message =
        'Report export task started. Requested file will be available in Notifications panel soon.'
    } else if (type === 'gdpr') {
      message =
        '"Personal Data" export task started. Requested file will be available in Notifications panel soon.'
    }
    NotificationToast('success', message)
  } catch (error) {
    NotificationToast('error', 'Your export request failed. Try again later.')
  }
}
